class algolia_custom_helpers {

  constructor() {
  }

  init() {
    this.localData = {};
  }


  // Get product metafields
  getProductMetafieldsAndProcessPrices(hit, perPage, autocomplete = false, callback = null) {

    let _this = this;
    // Wait for the cards to finish rendering, then update prices if required
    setTimeout(function () {
      _this.calculateCustomMinMaxPrices(hit, autocomplete, callback);
    }, 100);
  }

  // Calculate custom prices from product metafields
  calculateCustomMinMaxPrices(hit, autocomplete = false, callback = null) {
    let card = document.querySelector(`[data-algolia-position="${hit.__position}"]`);
    let target = null;
    let target2 = null;

    // This includes the embroidery logo price, if there is an embroidery logo required on a product
    let priceList = null;
    if (hit.meta.hasOwnProperty('prices') &&
      hit.meta.prices.hasOwnProperty('price-lists') &&
      hit.meta.prices['price-lists'].length > 0) {
      priceList = JSON.parse(hit.meta.prices['price-lists']);
    }

    let variantAutoDiscount = null;
    if (hit.meta.hasOwnProperty('multistore') &&
      hit.meta.multistore.hasOwnProperty('variant_auto_discounts') &&
      hit.meta.multistore.variant_auto_discounts.length > 0) {
      variantAutoDiscount = JSON.parse(hit.meta.multistore.variant_auto_discounts);
    }

    if (autocomplete) {
      card = document.querySelector(`.aa-ItemLink[href="/products/${hit.handle}/"]`);
    }

    if (card) {
      target = card.querySelector(`.ais-hit--price b`);

      if (autocomplete) {
        target = card.querySelector('.aa-ItemContentPrice.custom-price .aa-ItemContentPriceCurrent');
        target2 = card.querySelector('.aa-ItemContentPrice:not(.custom-price) .aa-ItemContentPriceCurrent');
      }
    }

    let parent1, parent2 = null;
    if (target) {
      parent1 = target.closest('.aa-ItemContentPrice');
      if (!parent1) parent1 = target.closest('.ais-hit--price');
    }
    if (target2) {
      parent2 = target2.closest('.aa-ItemContentPrice');
      if (!parent2) parent2 = target2.closest('.ais-hit--price');
    }

    // If we don't have all data, show the default price and return
    if (!window.hasOwnProperty('multistore_id')) {
      if (parent2) parent2.classList.remove('active');
      else if (parent1) parent1.classList.add('active');
      return;
    }
    if (!priceList) {
      if (parent2) {
        parent2.classList.add('active');
        if (parent1) parent1.classList.remove('active');
      } else if (parent1) parent1.classList.add('active');
    }

    let minPrice = null;
    let maxPrice = null;
    let storeString = 'store_' + window.multistore_id;
    let discountCalculated = false;

    // Get min and max prices from all variants
    if (priceList) {
      for (const [variantId, prices] of Object.entries(priceList)) {

        let discount = 0;
        // get variant auto discount
        if (variantAutoDiscount && variantAutoDiscount.hasOwnProperty(variantId)) {
          if (typeof variantAutoDiscount[variantId] != "undefined" && variantAutoDiscount[variantId].length > 0) {
            let variantDiscounts = JSON.parse(variantAutoDiscount[variantId]);
            if (variantDiscounts) {
              variantDiscounts.some((discountData) => {
                let splitDiscount = discountData.split(':');
                let storeId = splitDiscount[0];
                if (parseInt(storeId) == window.multistore_id) {
                  let discountValue = parseInt(splitDiscount[1]);
                  if (!isNaN(discountValue)) {
                    discount = discountValue;
                    discountCalculated = true;
                  }
                  return true;
                }
              });
            }
          }
        }

        discount = (100 - discount) / 100;

        if (prices.hasOwnProperty(storeString)) {
          let price = prices[storeString];

          // If price is an object, try to get the price based on customer wizard results
          if(typeof price == 'object') {
            if(window.hasOwnProperty('wizard_answers') && price.hasOwnProperty(window.wizard_answers)) {
              price = price[window.wizard_answers];
            }
          }

          if (price < minPrice || !minPrice) minPrice = (price * discount).toFixed(2);
          if (price > maxPrice || !maxPrice) maxPrice = (price * discount).toFixed(2);
          discountCalculated = true;
        } else if (prices.hasOwnProperty(hit.objectID)) {
          if (prices[hit.objectID].hasOwnProperty(storeString)) {
            let price = prices[hit.objectID][storeString];

            if (price < minPrice || !minPrice) minPrice = (price * discount).toFixed(2);
            if (price > maxPrice || !maxPrice) maxPrice = (price * discount).toFixed(2);
            discountCalculated = true;
          }
        }
      }
    }

    let variantPrices = null;
    if (hit.meta.hasOwnProperty('stores') &&
      hit.meta.stores.hasOwnProperty('variant_prices') &&
      hit.meta.stores.variant_prices.length > 0) {
      variantPrices = hit.meta.stores.variant_prices.split(',');
    }

    // get variant auto discount for products without product prices metafield
    if (!discountCalculated && variantPrices && variantPrices.length > 0) {

      variantPrices.forEach((variantData) => {
        variantData = variantData.split(':');
        let variantId = variantData[0];
        let price = parseFloat(variantData[1]);
        let discount = 0

        if (variantAutoDiscount && variantAutoDiscount.hasOwnProperty(variantId)) {
          if (typeof variantAutoDiscount[variantId] != "undefined" && variantAutoDiscount[variantId].length > 0) {
            let variantDiscounts = JSON.parse(variantAutoDiscount[variantId]);
            if (variantDiscounts) {
              variantDiscounts.some((discountData) => {
                let splitDiscount = discountData.split(':');
                let storeId = splitDiscount[0];
                if (parseInt(storeId) == window.multistore_id) {
                  let discountValue = parseInt(splitDiscount[1]);
                  if (!isNaN(discountValue)) {
                    discount = discountValue;
                  }
                  return true;
                }
              });
            }
          }
        }

        discount = (100 - discount) / 100;

        if (price < minPrice || !minPrice) minPrice = (price * discount).toFixed(2);
        if (price > maxPrice || !maxPrice) maxPrice = (price * discount).toFixed(2);

      });
    }

    if (maxPrice < minPrice) {
      let _minPrice = minPrice;
      minPrice = maxPrice;
      maxPrice = _minPrice;
    }

    if(minPrice) {
      minPrice = parseFloat(minPrice).toFixed(2);
    }
    if(minPrice) {
      maxPrice = parseFloat(maxPrice).toFixed(2);
    }

    let minMax = null;
    if (minPrice && maxPrice && minPrice != maxPrice) {
      minMax = `$${minPrice} - $${maxPrice}`;
    } else if (minPrice && !maxPrice) {
      minMax = '$' + minPrice;
    } else if (!minPrice && maxPrice) {
      minMax = '$' + maxPrice;
    }

    if (typeof callback == 'function') callback();

    if (minMax) {
      if (card) {
        if (target) {
          target.innerText = minMax;
          if (parent1) {
            parent1.classList.add('active');

            if (parent2) {
              parent2.classList.remove('active');
            }
          }
        }
      }
    } else if (parent2) {
      parent2.classList.add('active');
      if (parent1) {
        parent1.classList.remove('active');
      }
    } else if (parent1) {
      parent1.classList.add('active');
      if (parent2) {
        parent2.classList.remove('active');
      }
    }
  }

  getProductSwatchesCount(hit, autocomplete = false) {

    this.localData = sessionStorage.getItem('product_swatches_count') ? JSON.parse(sessionStorage.getItem('product_swatches_count')) : {};
    let _this = this;
    let hasLocalData = this.localData.hasOwnProperty(hit.handle);

    if (hasLocalData) {
      // Give it some time so cards finish rendering
      setTimeout(function () {
        _this.addSwatchesCountToCard(hit, _this.localData[hit.handle], autocomplete);
      }, 50);
    } else {

      // Get product data and save it in session storage after a second (so all data is ready)
      fetch(`/products/${hit.handle}?view=swatches-count`)
        .then(res => res.json())
        .then(response => {

          _this.localData = sessionStorage.getItem('product_swatches_count') ? JSON.parse(sessionStorage.getItem('product_swatches_count')) : {};
          _this.localData = {..._this.localData, ...response};

          sessionStorage.setItem('product_swatches_count', JSON.stringify(_this.localData));
          _this.addSwatchesCountToCard(hit, _this.localData[hit.handle], autocomplete);

        });
    }
  }

  addSwatchesCountToCard(hit, data, autocomplete = false) {
    if(!data || data < 1) return;
    let card = document.querySelector(`[data-algolia-position="${hit.__position}"]`);

    if (autocomplete) {
      card = document.querySelector(`.aa-ItemLink[href="/products/${hit.handle}/"]`);
    }

    let target = card.querySelector('.ais-hit--swatches-count');
    target.textContent = target.textContent.replace('[[VALUE]]', data);
    target.classList.remove('hidden');
  }
}